import React, { useState } from 'react';
import '../App.css';
import './tool.css';
import CSS from 'csstype';

// images

// classes
import { CheckOverflow } from '../utils/functions';
import { ShortenText } from '../utils/functions';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export function CheckBox(props: {
  name: string;
  value: string;
  text: string;
  checked: boolean;
  margin?: number;
  onChange: any;
  enabled?: boolean;
}) {
  //
  // the text to display in the tool.
  const [sToolText, setToolText] = useState<string>(props.text);
  const [sToolTextWithoutDots, setToolTextWithoutDots] = useState<string>(props.text);

  // check the Label element to see if the text has overflowed.
  const monitorLabelForOverflow = React.useRef<HTMLLabelElement | null>(null);

  // remove one character at a time from the text until it no longer causes an overflow.
  if (CheckOverflow({ ref: monitorLabelForOverflow, text: sToolText }) === true)
    ShortenText({
      text: sToolTextWithoutDots,
      setText: setToolText,
      setTextWithoutDots: setToolTextWithoutDots,
    });

  //	------------------------------------------------------------
  //
  //	Component code
  //
  //	------------------------------------------------------------

  return (
    <label
      className="checkbox"
      ref={monitorLabelForOverflow}
      style={{
        overflow: 'auto',
        flex: '0 0 auto',
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '35px',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      data-disabled={props.enabled === false ? 'T' : 'F'}
    >
      <div
        style={{
          flex:
            '0 0 ' + (props.margin !== undefined ? props.margin : 5).toString() + 'px',
        }}
      />
      <div className="panel-background" style={{ flex: '0 0 5px', height: '19px' }} />
      <input
        aria-label={props.text}
        type="checkbox"
        checked={props.checked}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        disabled={props.enabled === false}
      ></input>
      <div
        className="panel-background"
        style={{ flex: '0 0 auto', padding: '0px 10px 0px 5px' }}
      >
        {sToolText}
      </div>
      <div style={{ flex: '1 1' }} />
    </label>
  );
  //
} // CheckBox
